import React, { useState } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import ds from '../../Services/DataServices'
import IntlMessages from '../../util/IntlMessages'
import { Button, Spin, Form, List, Modal } from 'antd'
import CustomScrollbars from '../../util/CustomScrollbars'
import {
  isEmptyObject,
  notAllowMsgCheck
} from '../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import { CloseOutlined, PrinterFilled } from '@ant-design/icons'
import { useCookies } from 'react-cookie'
import { env } from '../../env'
import {
  getPrintStringForOpenClose,
  getPrintStringForReceipt,
  getPrintStringForXZReport
} from '../PrintString'
import { GetIndexDBDataByTableName } from '../../appRedux/actions/IndexDBActions'
import { INDEX_DB_NAME, INDEX_DB_TABLES } from '../../constants/IndexDBData'
import { checkIsWeb } from '../../appRedux/actions/MobAppFn'
const {
  REACT_APP_LOCALIP_PRINT_HTTP,
  REACT_APP_PROXY_SERVER,
  TS_COOKIE_BASE_DOMAIN
} = env

const expires_in = 18

const ChoosePrinter = props => {
  const {
    visible,
    hide,
    getCurrData,
    outletName,
    registerName,
    data,
    callBackDefault,
    XZData,
    printExtraData,
    decimal,
    storeInfo,
    showRefID,
    showSaleTax,
    showSaleDate,
    showTotalAmount,
    showTotalTax
  } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()

  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [getIsSpinning, setIsSpinning] = useState(true)
  const [getData, setData] = useState([])
  const [getCurrentPageNo, setCurrentPageNo] = React.useState(1)
  const [getPageSize, setPageSize] = React.useState(10)
  const [getTotalRecords, setTotalRecords] = React.useState(1)
  const [callBackType, setCallBackType] = React.useState(0)
  const [getPrintData, setPrintData] = React.useState(0)
  const [cookies, setCookie, removeCookie] = useCookies([
    'printHTML',
    'ip',
    'port'
  ])

  React.useEffect(() => {
    let mounted = true
    if (mounted && visible) {
      if (isOnline) {
        getPrintListing({
          CurrentPageNo: getCurrentPageNo,
          PageSize: getPageSize,
          Type: 'to_print',
          IsTabletPrinter: !checkIsWeb().exist,
          platform: localStorage.getItem('platform_stored')
            ? localStorage.getItem('platform_stored')
            : ''
        })
      } else {
        getPrintersFromIndex()
      }

      if (printExtraData && !isEmptyObject(printExtraData)) {
        setPrintData(printExtraData)
        setCallBackType(3)
      } else if (XZData && !isEmptyObject(XZData)) {
        setPrintData(XZData)
        setCallBackType(2)
      } else if (data) {
        setPrintData(data)
        setCallBackType(1)
      }
    }
    return () => (mounted = false)
  }, [visible, isOnline])

  // React.useEffect(() => {
  //   let mounted = true
  //   if (mounted) {
  //     if (printExtraData && !isEmptyObject(printExtraData)) {
  //       setPrintData(printExtraData)
  //       setCallBackType(3)
  //     } else if (XZData && !isEmptyObject(XZData)) {
  //       setPrintData(XZData)
  //       setCallBackType(2)
  //     } else if (data) {
  //       setPrintData(data)
  //       setCallBackType(1)
  //     }
  //   }
  //   return () => (mounted = false)
  // }, [data, XZData, printExtraData])

  async function getPrintListing (body) {
    const req = ds.getPrintersService(body, BEHAVIOUR_TYPE.GET)
    await req
      .then(res => {
        processPrinters(res, body, 'getPrintListing')
      })
      .catch(e => {
        setTotalRecords(1)
        notAllowMsgCheck(e)
        setIsSpinning(false)
      })
  }

  function getPrintersFromIndex () {
    const data = GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.PRINTERS
    )
    data
      .then(res => {
        const plat = localStorage.getItem('platform_stored')
          ? localStorage.getItem('platform_stored')
          : ''
        res = res && res.length > 0 ? res.filter(d => d.platform == plat) : []
        processPrinters(res, { CurrentPageNo: 1 }, 'getPrintersFromIndex')
      })
      .catch(e => {
        setTotalRecords(1)
        setIsSpinning(false)
        console.error('INDEX_DB -> getPrintersFromIndex -->', e)
      })
  }

  const pagination = {
    pageSize: getCurrentPageNo == 1 ? 11 : getPageSize,
    current: getCurrentPageNo,
    total: getTotalRecords,
    defaultPageSize: 10,
    hideOnSinglePage: true,
    // onChange: () => {},
    onChange: page => {
      setCurrentPageNo(page)
      setIsSpinning(true)
      let body = {
        CurrentPageNo: page,
        PageSize: getPageSize,
        Type: 'to_print',
        IsTabletPrinter: !checkIsWeb().exist,
        platform: localStorage.getItem('platform_stored')
          ? localStorage.getItem('platform_stored')
          : ''
      }
      getPrintListing(body)
    }
  }

  function processPrinters (res, body, from) {
    try {
      if (res && res.length > 0) {
        const totalRecords = res[0].totalRecords
        // let paginationobj = {
        //   CurrentPageNo: res[0].currentPageNo,
        //   PageSize: res[0].pageSize,
        //   total: res[0].totalRecords,
        //   showSizeChanger: true
        // }
        const arr = []
        if (body.CurrentPageNo && body.CurrentPageNo == 1) {
          arr.push({ printerID: 0, name: 'Default' })
        }
        res.map(a => {
          arr.push(a)
          // if (a.isActive) {
          //   totalRecords += 1
          //   arr.push(a)
          // }
        })
        setTotalRecords(totalRecords)
        setData(arr)
      }
      setIsSpinning(false)
    } catch (e) {
      console.error(
        `SETUP_INDEX_DB_CONFIGS_ERROR -> processPrinters_from_${from} -->`,
        e
      )
    }
  }

  function onPrintConfig (printData) {
    if (printData && getPrintData && callBackType) {
      if (printData.printerID == 0) {
        callBackDefault(callBackType)
      } else {
        let ip = false
        let port = false
        let hheader = ''
        let ffooter = ''
        let subtitle1 = ''
        let subtitle2 = ''
        let showDate = false
        let showOutlet = false
        let showRegister = false
        let showServedBy = false
        let showFooter = false
        let showHeader = false
        // let showServedBy = false
        if (printData) {
          ip = printData.ip ? printData.ip : false
          port = printData.port ? printData.port : false
          hheader = printData.header ? printData.header : ''
          ffooter = printData.footer ? printData.footer : ''
          subtitle1 = printData.subtitle1 ? printData.subtitle1 : false
          subtitle2 = printData.subtitle2 ? printData.subtitle2 : false
          showDate = printData.showDatetime ? true : false
          showOutlet = printData.showOutlet ? true : false
          showRegister = printData.showRegister ? true : false
          showServedBy = printData.showServedBy ? true : false
          showFooter = printData.showFooter ? true : false
          showHeader = printData.showHeader ? true : false
        }
        if (ip && port) {
          let expires = new Date()
          expires.setTime(expires.getTime() + expires_in * 1000)
          let dataPrint = getPrintData
          if (callBackType != 2) {
            dataPrint.outletName = outletName
          }
          dataPrint.mainRegister = registerName
          dataPrint.hheader = hheader
          dataPrint.ffooter = ffooter
          dataPrint.subtitle1 = subtitle1
          dataPrint.subtitle2 = subtitle2
          dataPrint.showDate = showDate
          dataPrint.showOutlet = showOutlet
          dataPrint.showRegister = showRegister
          dataPrint.showServedBy = showServedBy
          if (callBackType == 2) {
            dataPrint.showRefID = true // showRefID
            dataPrint.showSaleTax = false // showSaleTax
            dataPrint.showSaleDate = showSaleDate
            dataPrint.showTotalAmount = showTotalAmount
            dataPrint.showTotalTax = false // showTotalTax
          }
          if (storeInfo) {
            if (storeInfo.storeName) {
              dataPrint.storeName = storeInfo.storeName
            }
          }

          const recieptHTML =
            callBackType == 3
              ? getPrintStringForOpenClose(
                  dataPrint,
                  getCurrData.currencyCode,
                  decimal
                )
              : callBackType == 2
              ? getPrintStringForXZReport(
                  dataPrint,
                  getCurrData.currencyCode,
                  decimal
                )
              : getPrintStringForReceipt(
                  dataPrint,
                  getCurrData.currencyCode,
                  decimal
                )
          //console.log('receitp chooseprinters', recieptHTML)

          setCookie('ip', ip, {
            domain: TS_COOKIE_BASE_DOMAIN,
            path: '/'
            // expires
          })
          setCookie('port', port, {
            domain: TS_COOKIE_BASE_DOMAIN,
            path: '/'
            // expires
          })

          const excryptHTML = recieptHTML ? btoa(recieptHTML) : recieptHTML
          setCookie('printHTML', excryptHTML, {
            domain: TS_COOKIE_BASE_DOMAIN,
            path: '/'
            // ,expires
          })
          window.open(REACT_APP_PROXY_SERVER)
        }
      }
    }
    hidePopUP()
  }

  function hidePopUP () {
    setCallBackType(0)
    setPrintData(0)
    hide()
  }

  return (
    <Modal
      transitionName=''
      maskTransitionName=''
      visible={visible}
      // onCancel={() => {
      //   hidePopUP()
      // }}
      title={<h1>Choose Printer</h1>}
      width={402}
      bodyStyle={{ height: 500, overflowX: 'scroll' }}
      centered={true}
      closeIcon={
        <Button
          className='close-icon-print'
          shape='circle'
          icon={<CloseOutlined />}
          onClick={() => hidePopUP()}
        />
      }
      footer={null}
    >
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={getIsSpinning}
        size='large'
      >
        <List
          itemLayout='horizontal'
          pagination={isOnline ? pagination : true}
          dataSource={getData}
          renderItem={e => (
            <List.Item
              onClick={() => {
                onPrintConfig(e)
              }}
              key={e.printerID ? e.printerID : 0}
              className='ant-select-item custom-list-hover'
            >
              <List.Item.Meta
                title={
                  <div>
                    <p
                      style={{
                        fontSize: 'medium',
                        fontWeight: 500,
                        marginLeft: 12
                      }}
                    >
                      {e.name ? e.name : ''}
                    </p>
                  </div>
                }
              />
              <PrinterFilled style={{ marginRight: 22, fontSize: 'large' }} />
            </List.Item>
          )}
        />
      </Spin>
    </Modal>
  )
}

export default ChoosePrinter
